import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BoomboxIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M5.5 2.56348V4.9999H4V2.01348C4 1.48881 4.42533 1.06348 4.95 1.06348H11.131C11.6557 1.06348 12.081 1.48881 12.081 2.01348V4.9999H10.581V2.56348H5.5Z"
		></path>
		<path
			fill="currentColor"
			d="M4.75 11C4.75 11.4142 4.41421 11.75 4 11.75C3.58579 11.75 3.25 11.4142 3.25 11C3.25 10.5858 3.58579 10.25 4 10.25C4.41421 10.25 4.75 10.5858 4.75 11Z"
		></path>
		<path
			fill="currentColor"
			d="M12 11.75C12.4142 11.75 12.75 11.4142 12.75 11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11C11.25 11.4142 11.5858 11.75 12 11.75Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1 5.95C1 5.42533 1.42533 5 1.95 5H14.05C14.5747 5 15 5.42533 15 5.95V14.05C15 14.5747 14.5747 15 14.05 15H1.95C1.42533 15 1 14.5747 1 14.05V5.95ZM4 13C5.10457 13 6 12.1046 6 11C6 9.89543 5.10457 9 4 9C2.89543 9 2 9.89543 2 11C2 12.1046 2.89543 13 4 13ZM14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11ZM4.75 6C4.33579 6 4 6.33579 4 6.75C4 7.16421 4.33579 7.5 4.75 7.5H11.25C11.6642 7.5 12 7.16421 12 6.75C12 6.33579 11.6642 6 11.25 6H4.75Z"
		></path>
	</svg>
))
